import { html as a, when as n } from "@microsoft/fast-element";
const r = (s) => {
  const i = a.partial(s.prefix);
  return a`
    <div class="control" part="control">
      <slot name="icon">
        ${n(
    (t) => t.variant === "info",
    a` <${i}-icon
            class="variant-icon"
            name="information-circle"
          />`
  )}
        ${n(
    (t) => t.variant === "success",
    a` <${i}-icon class="variant-icon" name="check-circle" />`
  )}
        ${n(
    (t) => t.variant === "error",
    a` <${i}-icon
            class="variant-icon"
            name="exclamation-triangle"
          />`
  )}
      </slot>
      <div class="content" part="content">
        <slot></slot>
      </div>
      ${n(
    (t) => t.duration > 0,
    a`
          <${i}-timer
            class="duration-timer"
            duration="${(t) => t.duration}"
            ?start="${(t) => t.show}"
            @finished="${(t) => t.dismiss()}"
          />
        `
  )}
      ${n(
    (t) => t.dismissible,
    a`
          <${i}-button
            class="dismiss-button"
            variant="ghost"
            @click="${(t) => t.dismiss()}"
          >
            <${i}-icon name="x-mark" slot="start" />
          </${i}-button>
        `
  )}
    </div>
  `;
};
export {
  r as toastTemplate
};
